import { readFeatureTags } from '../tools/featureToggle/utils';

export async function getFeatureFlagHeaders() {
  const flagsStorage = readFeatureTags();

  if (flagsStorage) {
    return { 'Gfk-Flags': flagsStorage.join(',') };
  }
}
